import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Economy() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEconomyNews = async () => {
      try {
        const res = await fetch("https://ppmn.net/dash/api/Section/economic-news");
        const json = await res.json();
        setData(Array.isArray(json) ? json : []);
      } catch (err) {
        console.error("Failed to fetch economy news:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEconomyNews();
  }, []);

  if (loading) {
    return <div className="loader">جاري تحميل أخبار الاقتصاد...</div>;
  }

  return (
    <div className="container my-5">
      <div className="section-header mb-4">الاقتصاد</div>
      <div className="row">
        {data.map((item) => (
          <div
            className="col-xl-3 col-lg-4 col-md-6 mb-4"
            key={item.article_id}
          >
            <div
              className="card card-custom h-100"
              onClick={() =>
                navigate(`/News/economic-news/${item.article_id}/${item.article_slug}`)
              }
              style={{ cursor: "pointer" }}
            >
              <div className="image-container">
                <img
                  src={item.article_title_image}
                  alt={item.article_title}
                  className="card-img-top"
                  loading="lazy"
                />
                <div className="publish-time-left text-black-50">
                  {item.article_published_before || "بدون تاريخ"}
                </div>
              </div>
              <div className="card-body">
                <h6 className="card-title">{item.article_title}</h6>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
